import axios from "axios";
import store from "../index";
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
const state = {
    items:[],
    item : [],
    index:'',
    sortBy:'',
    sortDesc:'',




};

const getters = {
    getItems: state => {
        return state.items;
    },
    getItem: state => {
        return state.item;
    },
    getIndex: state => {
        return state.index;
    },
    getSortBy: state => {
        return state.sortBy;
    },
    getSortDesc: state => {
        return state.sortDesc;
    },



};

const actions = {

    searchCustomers : async (context,payload) => {

        let url = "customers";

        return await   axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': {
                    "sortBy": payload.settings.sortBy,
                    'sortDesc': payload.settings.sortDesc,
                    'page': payload.settings.page,
                    'itemsPerPage': payload.settings.itemsPerPage,
                    'filters': (payload.settings.filters) ? payload.settings.filters:'',
                    'search': payload.settings.search
                }
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {
                return res.data.data
            })
            .catch(err => {


                console.log("errore", err);

            });

    },

    asyncFetchData : async (context,settings) => {

        const {sortBy, sortDesc, page, itemsPerPage} = settings.options;
        let url = "customers";

        context.commit('setSortDesc', sortDesc[0]);
        context.commit('setSortBy', sortBy[0]);
        //console.log(context.rootGetters['categories/getSortBy'])
        return await   axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': {
                    "sortBy": context.rootGetters['customers/getSortBy'],
                    'sortDesc': context.rootGetters['customers/getSortDesc'],
                    'page': page,
                    'itemsPerPage': itemsPerPage,
                    'filters': (settings.filters)?settings.filters:'',
                    'search': settings.search
                }
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {

                context.commit('setItems', res.data.data);
                return res.data.pagination
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });

    },

    deleteItems : async (context,settings) => {
        let url = "customers/delete";
        //console.log(context.rootGetters['categories/getSortBy'])
        return await   axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': {
                    "query": settings
                }
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            }
        )
            .then(res => {
                //console.log(res.data.pagination);
                //context.commit('setCategories', res.data.data);
                return res.data
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err.response.status);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }*/
                return {error:err.response.status}
                //throw Error(err.response.status);
            });

    },




    getDetailItem : async (context,payload) =>{
        //console.log(payload)
        let url = `customers/detail/${payload.id}`;

        return await   axios.get(`${context.rootGetters['settings/getUrl']}${url}`,

            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {
                //console.log(res);
                context.commit('setItem', res.data.data);
                return {data:res.data}
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
              /*  if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });
    },


    destroyData : (context) =>{
        context.commit('setItems',[]);
        context.commit('setItem',{});
        context.commit('setIndex','');



    },


};

const mutations = {
    setItems: (state,value) => {
        state.items= value;
    },
    setItem: (state,value) => {
        state.item= value;
    },
    setSortBy: (state,value) => {
        state.sortBy= value;
    },
    setIndex: (state,value) => {
        state.index= value;
    },
    setSortDesc: (state,value) => {
        state.sortDesc= value;
    },


};



export default {
    namespaced : true,
	state,
	mutations,
	getters,
	actions
}
